import { matterConstant } from "../_constants/matter.constant"
import { matterService } from "../_services/matter.service";
import { alert } from "../_utilities/alert";

export const matterAction = {

    createMatterDetail,
    getMatterDetail,
}

function createMatterDetail(data) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: matterConstant.CREATE_MATTER_REQUEST,
                data: null
            })
        );
        
        matterService
        // return matterService
            .createMatterDetail(data)
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: matterConstant.CREATE_MATTER_SUCCESS,
                                data: response.Result.matter
                            })
                        );
                        alert.success(response.Message)
                        // console.log(77,response);
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: matterConstant.CREATE_MATTER_FAILURE,
                                data: null
                            })
                        );
                        alert.error(response.Message);
                    }
                    // return response;
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: matterConstant.CREATE_MATTER_FAILURE,
                            data: error
                        })
                    );
                    alert.error("Oops! Something went wrong!!");
                    //  throw error; 
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
                     throw error; 

            });
    }
}

function getMatterDetail() {
    return (dispatch) => {
        console.log(12,dispatch);
        
        dispatch(
            dispatchFunction({
                type: matterConstant.GET_MATTER_REQUEST,
                data: null
            })
        );
        matterService
            .getMatterDetails()
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: matterConstant.GET_MATTER_SUCCESS,
                                data: response.Result.metter,
                            })
                        );
                        console.log(31,response);
                        
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: matterConstant.GET_MATTER_FAILURE,
                                data: null,
                            })
                        );
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: matterConstant.GET_MATTER_FAILURE,
                            data: error,
                        })
                    );
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
            });
    }
}


function dispatchFunction(data) {
    return {
        type: data.type,
        data: data.data
    }
}

